import React from 'react'
import { findDOMNode } from 'react-dom'
import tippy from 'tippy.js'
import { tippyDefaults } from 'lib/tippyDefaults'

export class WithTooltip extends React.PureComponent {
  // see https://atomiks.github.io/tippyjs/ for all possible values
  static defaultProps = {
    ...tippyDefaults
  }
  componentDidMount () {
    const node = findDOMNode(this)
    const { children, show, ...tooltipOptions } = this.props
    tippy(node, tooltipOptions)
    this._tippy = node._tippy
    if (tooltipOptions.trigger === 'manual' && show) {
      this._tippy.show()
    }
  }

  componentWillUnmount () {
    this._tippy.destroy()
  }

  render () {
    return this.props.children
  }
}
